import React from "react";
import TextArea from "../../../../widget/common/form/Textarea";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { AutomatedReplyContextImport } from "../../../../provider/work_profile/automated_reply/AutomatedReplyContextProvider";
import { OffOn } from "../../../../widget/common/ui/Checkbox";
import { TextBlock } from "../../../../widget/common/ui/Text";

export const AutomatedReplyToggleField = () => {
  const { statusField, handleOnChange } = AutomatedReplyContextImport();

  return (
    <OffOn
      name="toggle-activate"
      value={statusField}
      handleOnChange={handleOnChange}
    />
  );
};

export const AutomatedReplyMessageField = () => {
  const { messageField, handleOnChange, maxWords } =
    AutomatedReplyContextImport();

  return (
    <>
      <TextBlock
        fontName="book"
        fontSize="13_14"
        textColor="theme-label"
        className="px-2 pt-3"
      >
        {AppTranslation.text("message")}
      </TextBlock>
      <TextArea
        name="message"
        rowSize={8}
        maxWords={maxWords}
        placeHolder={AppTranslation.text("type_here_max_200_chars")}
        handleOnChange={handleOnChange}
        value={messageField}
        validate={true}
        error={false}
      />
    </>
  );
};
